import { api } from "../utils/apiClientWithCsrf";
import { API_WATCHLIST_URL, getSearchApiUrl } from "../utils/apiUrlList";
import { TRACK_EVENT_SELECTION_KEY } from "../TrackEventSelector";

export const getWatchListDrivers = async (userId) => {
  try {
    const response = await api.get(API_WATCHLIST_URL, {
      params: { userId: userId },
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching watchlist:", error);
    return [];
  }
};

export const fetchRaceHistoryByDriver = async (driverName, carNumber, searchPage = 0) => {
  try {
    const trackEventSelectionValue = JSON.parse(localStorage.getItem(TRACK_EVENT_SELECTION_KEY));

    if (!trackEventSelectionValue) {
      console.error("Track/Event selection not found in localStorage");
      return [];
    }

    const requestData = {
      eventFromDate: "",
      eventToDate: "",
      category: "",
      round: "",
      trackId: trackEventSelectionValue.trackId,
      carClass: "",
      driverName: driverName || "",
      carNo: carNumber || "",
      startET: "",
      endET: "",
      eventId: trackEventSelectionValue.eventId,
      sortBy: "",
      sortOrder: "",
    };

    const apiUrl = getSearchApiUrl(searchPage);

    const response = await api.post(apiUrl, requestData, {
      withCredentials: true,
    });

    return response.data || [];
  } catch (error) {
    console.error("Error fetching race history:", error);
    return [];
  }
};

const formatDateRaceUniqueId = (timestamp) => {
  try {
    const datePart = timestamp.substring(0, 10);
    const [month, day, year] = datePart.split("-");

    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const monthName = monthNames[parseInt(month, 10) - 1];

    const timePart =
      timestamp.substring(11, 13) +
      ":" +
      timestamp.substring(14, 16) +
      ":" +
      timestamp.substring(17, 19);

    return `${day}/${monthName}/${year} ${timePart}`;
  } catch (error) {
    console.error("Error formatting date:", error);
    return "NA";
  }
};

export const formatRaceData = (data) => {
  return data.map((event) => ({
    raceKey: event.raceKey || "N/A",
    date: formatDateRaceUniqueId(event.raceUniqueId),
    round: event.round || "-",
    category: event.category || "-",
    carClass: event.carClass || "-",
    win: event.win === "W" || event.win === "WIN" ? true : false,
    opponentName: event.opponentDriver?.driver || "N/A",
    opponentCarNo: event.opponentDriver?.carNo || "N/A",
    dialIn: typeof event.dialIn === "number" ? event.dialIn.toFixed(3) : event.dialIn || "N/A",
    rt: typeof event.rt === "number" ? event.rt.toFixed(3) : event.rt || "N/A",
    ft60: typeof event.ft60 === "number" ? event.ft60.toFixed(3) : event.ft60 || "N/A",
    ft330: typeof event.ft330 === "number" ? event.ft330.toFixed(3) : event.ft330 || "N/A",
    ft8: typeof event.ft8 === "number" ? event.ft8.toFixed(3) : event.ft8 || "N/A",
    ft8mph: typeof event.ft8mph === "number" ? event.ft8mph.toFixed(3) : event.ft8mph || "N/A",
    ft1000: typeof event.ft1000 === "number" ? event.ft1000.toFixed(3) : event.ft1000 || "N/A",
    ft4: typeof event.ft4 === "number" ? event.ft4.toFixed(3) : event.ft4 || "N/A",
    ft4mph: typeof event.ft4mph === "number" ? event.ft4mph.toFixed(3) : event.ft4mph || "N/A",
  }));
};
